import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  userImage: {
    width: '100px',
    height: '100px'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  }
};

const enhance = compose(connect());

const ShopTable = enhance(
  ({
    classes,
    shopName,
    groupName,
    childFoodId,
    childFoodName,
    menuChild,
    childFoodDescription,
    createdAt,
    updatedAt,
    childFoodImage
    // tags,
  }) => {
    return (
      <Table className={classes.detailTable}>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCellItem}>メニューID</TableCell>
            <TableCell className={classes.tableCellData}>
              {childFoodId}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>メニュー名</TableCell>
            <TableCell className={classes.tableCellData}>
              {childFoodName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>店舗名</TableCell>
            <TableCell className={classes.tableCellData}>{shopName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              連携グループ
            </TableCell>
            <TableCell className={classes.tableCellData}>{groupName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              該当のお食事券
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {!menuChild && ' 未登録'}
              {menuChild && menuChild}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>説明</TableCell>
            <TableCell className={classes.tableCellData}>
              {childFoodDescription}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>画像</TableCell>
            <TableCell className={classes.tableCellData}>
              {childFoodImage &&
                childFoodImage.map(image => {
                  return (
                    <Card className={classes.userImage}>
                      <CardActionArea>
                        <CardMedia component="img" image={image.image} />
                      </CardActionArea>
                    </Card>
                  );
                })}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>登録日時</TableCell>
            <TableCell className={classes.tableCellData}>{createdAt}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>更新日時</TableCell>
            <TableCell className={classes.tableCellData}>{updatedAt}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }
);

export default withStyles(styles)(ShopTable);
